var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height justify-center",attrs:{"id":"register","tag":"section"}},[_c('Overlay',{attrs:{"overlay":_vm.globalLoading,"color":'primary'}}),_c('Messages',{attrs:{"messages":_vm.globalMessages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }